<template>
  <div style="height: 100%">
    <div style="display: flex; overflow: hidden; height: 870px" class="padHeight">
      <div class="task-details-left" :style="{ width: isshow ? '20px' : '340px' }">
        <div style="display: flex; justify-content: flex-end; font-size: 24px; margin-top: 10px; margin-right: 10px">
          <i v-if="isshow" class="el-icon-right" @click="back"></i>
          <i v-else class="el-icon-back" @click="back"></i>
        </div>
        <div style="display: flex; margin-top: 38px; margin-left: 31px; margin-bottom: 20px" class="peoplePic">
          <img src="../../assets/image/icon/avatar60.png" alt="" />
          <div style="margin-left: 20px">
            <span class="span-name">{{ PObj.Name }}</span>
            <span class="span-text">{{ PObj.Age }}岁</span>
            <span class="span-text">{{ PObj.Sex == 1 ? '男' : '女' }}</span>
            <img src="../../assets/image/icon/boy-sex.png" alt="" v-if="PObj.Sex == '1'" />
            <img src="../../assets/image/icon/female-sex.png" alt="" v-else />
            <div>
              <span class="span-text">{{ PObj.Tel }}</span>
            </div>
          </div>
        </div>
        <div class="call-phone">
          <el-button type="primary">一键呼叫</el-button>
        </div>
        <div style="margin-bottom: 16px">
          <el-radio-group v-model="radio1">
            <el-radio-button label="随访信息"></el-radio-button>
            <el-radio-button label="数据核查"></el-radio-button>
          </el-radio-group>
        </div>
        <div v-show="radio1 == '数据核查'" class="show-beizhu">
          <el-input type="textarea" placeholder="填写建议" v-model="textarea" maxlength="300" show-word-limit style="width: 300px; font-size: 16px" rows="4" />
          <div style="margin-top: 10px; margin-bottom: 20px">
            <el-button style="width: 300px; background: #3388ff; color: #fff" @click="handleSubmit">提交</el-button>
          </div>
          <div>
            <span class="span-task-details">共计{{ total2 }}条</span>
          </div>
          <ul style="overflow-y: scroll; overflow-x: hidden; height: 380px">
            <li v-for="(item, idx) in dataList" :key="item.Id">
              {{ idx + 1 }}.
              <span class="span-text" style="color: #333">核查人:</span>
              <span class="span-text" style="color: #333">{{ item.OwnerName }}</span>
              <span class="span-time">{{ item.CreateTime }}</span>
              <div class="bei-zhu-info">
                <div>
                  <el-input type="textarea" v-model="editVal" v-if="editShow === idx" @blur="handleBlur(item, idx)"></el-input>
                  <span v-else>{{ item.Comment | ellipsis }}</span>
                </div>
                <div style="position: absolute; right: 20px; bottom: 0; z-index: 999" v-show="isShow">
                  <el-tooltip placement="bottom" effect="light">
                    <div slot="content">
                      <p style="cursor: pointer">
                        <i class="el-icon-edit-outline"></i>
                        修改备注
                      </p>
                      <el-divider></el-divider>
                      <p style="cursor: pointer">
                        <i class="el-icon-delete"></i>
                        删除备注
                      </p>
                    </div>
                    <i class="el-icon-more" style="cursor: pointer"></i>
                  </el-tooltip>
                </div>
              </div>
              <div style="transform: translateY(-15px)" v-if="UserId === item.CreateBy">
                <el-button size="mini" type="warning" @click="handleEdit(item, idx)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleRemove(item, idx)">删除</el-button>
              </div>
            </li>
            <div class="loadMore">
              <div v-if="isLoad" ref="isLoad">加载中</div>
              <div v-else>暂无更多数据</div>
            </div>
          </ul>
        </div>
        <div v-show="radio1 == '随访信息'" style="margin-top: 30px" class="show-shufang">
          <!-- <div v-if="list.length == 0" class="no-content">
            <img src="../../assets/image/icon/no-data.png" alt="">
            <p>暂无随访信息</p>
          </div> -->
          <div>
            <ul @scroll="Scroll" style="overflow-y: scroll; overflow-x: hidden; height: 580px">
              <div style="margin-bottom: 20px">
                <p>所属项目:{{ ProjectName }}</p>
              </div>
              <li v-for="(item, index) in list" :key="index" style="position: relative; cursor: pointer" @click="EditQuestionnaire(item, index)">
                <div style="margin-bottom: 10px">
                  <p @click="EditQuestionnaire(item, index)">
                    {{ item.QuestionnaireName }}
                  </p>
                </div>
                <div class="task-content" style="margin-bottom: 20px" :class="{ active: active == index }">
                  <div>
                    <span>随访时间:</span>
                    <!-- <span>{{item.TriggerTime}}</span> -->
                    <span>{{ item.EndTime ? item.EndTime : item.BeginTime }}</span>
                  </div>
                  <div>
                    <span>随访状态</span>
                    <span>{{ item.StatusName }}</span>
                  </div>
                  <div>
                    <span>访视次数:</span>
                    <span>{{ item.Frq }}</span>
                  </div>
                  <div style="position: absolute; right: 5%; bottom: 9%">
                    <el-link :underline="false" @click="DeleteQuestionnaire(item)">
                      <i class="el-icon-delete"></i>
                    </el-link>
                  </div>
                </div>
                <!-- <div style="position: absolute;bottom:0;right:20px;cursor:pointer;">
                   <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                             <i class="el-icon-more-outline" style="font-size: 26px;"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="ViewQuestionnaire(item)">查看问卷</el-dropdown-item>
                          <el-dropdown-item @click.native="EditQuestionnaire(item)">修改问卷</el-dropdown-item>
                          <el-dropdown-item @click.native="DeleteQuestionnaire(item)">删除问卷</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                 </div> -->
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="task-details-right">
        <iframe v-if="Url != ''" :src="Url" frameborder="0" width="100%" height="880px" ref="myFrame" id="iframe"></iframe>
        <div class="no-content" v-else>
          <img src="../../assets/image/icon/no-content.png" alt="" />
          <p>暂无随访信息</p>
        </div>
        <!-- <div class="btn" v-if="list.length>0"><el-button type="danger"  @click="DeleteQuestionnaire">删除问卷</el-button></div> -->
        <video id="videocalss" :src="videoUrl" controls v-show="videoUrl != ''"></video>
      </div>
    </div>
  </div>
</template>

<script>
import derive from '../../api/derive';
import { local } from '../../utils/storage';
export default {
  name: 'TaskDetails',
  data() {
    return {
      active: null,
      isShow: false,
      beizhu: '今天是我在备注信息，今天是我在备注信息，今天是我在备注信息，今天是我在备注信息，今天是我在备注信息，' + '22222222222222222222今天是我在备注信息......',
      textarea: '',
      radio1: '随访信息',
      Url: '',
      list: [],
      flag: false,
      page: 1,
      total: 0,
      item: {},
      ProjectName: local.get('ProjectName'),
      videoUrl: '',
      isshow: false,
      devicePixelRatio: '',

      params: {
        FollowUpTaskId: '',
        page: 1,
        rows: 5
      },
      dataList: [],
      total2: 0,
      UserId: local.get('UserId'),
      isLoad: true,
      editVal: '',
      editShow: false
    };
  },
  props: ['PObj'],
  filters: {
    ellipsis(value) {
      if (!value) return '';
      if (value.length > 60) {
        return value.slice(0, 60) + '...';
      }
      return value;
    }
  },
  created() {
    this.IsPC();
    window.addEventListener('message', e => {
      if (e.data == true) {
        this.RefreshFollowUpRecords();
      }
    });
    this.FollowUpRecords();
  },
  // watch: {
  //   Url: {
  //     deep: true,
  //     handler(oldval,newval) {
  //       if(!newval) return;
  //       this.$nextTick(()=>{
  //         console.log(oldval,newval,'val')
  //         console.log(document.getElementById('iframe'));
  //         document.getElementById('iframe').contentWindow.location.reload(true)
  //       })
  //     }
  //   }
  // },
  methods: {
    IsPC() {
      //   var userAgentInfo = navigator.userAgent; // 包含有关浏览器的信息// 非手机端
      //   var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
      //   var flag = true;
      //   for (var v = 0; v < Agents.length; v++) {
      //     if (userAgentInfo.indexOf(Agents[v]) > 0) {
      //       flag = false;
      //       break;
      //     }
      //   }
      // return flag;
      // let userAgentInfo = navigator.userAgent;
      // let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
      // let getArr = Agents.filter(i => userAgentInfo.includes(i));
      // return getArr.length ? true : false;
      this.devicePixelRatio = document.documentElement.clientWidth < 1100;
    },
    back() {
      this.isshow = !this.isshow;
    },
    RefreshFollowUpRecords() {
      const parameter = {
        Key: '',
        page: this.page,
        rows: 4,
        ProjectPatientId: this.PObj.Id
      };
      derive.FollowUpRecordsData(parameter).then(res => {
        if (res.data.Status == 1) {
          if (res.data.Data.rows.length > 0) {
            this.total = res.data.Data.total;
            this.list = res.data.Data.rows;
          }
        } else {
          alert(res.data.Message);
        }
      });
    },

    //创建iframe节点
    createIframe(dom, src) {
      //在document中创建iframe
      var iframe = document.createElement('iframe');
      //设置iframe的样式
      iframe.style.width = '100%';
      iframe.style.height = '880px';
      iframe.src = src;
      //把iframe载入到dom以下
      dom.appendChild(iframe);
      return iframe;
    },
    //随访记录
    FollowUpRecords() {
      this.videoUrl = '';
      const parameter = {
        Key: '',
        page: this.page,
        rows: 4,
        ProjectPatientId: this.PObj.Id
      };
      derive.FollowUpRecordsData(parameter).then(res => {
        if (res.data.Status == 1) {
          if (res.data.Data.rows.length > 0) {
            this.total = res.data.Data.total;
            this.list = this.list.concat(res.data.Data.rows);
            if (this.page == 1) {
              if (this.list[0].Status == '08' || this.list[0].Status == '06' || this.list[0].Status == '05') {
                if (this.list[0].VoiceFile != null) {
                  this.videoUrl = this.list[0].VoiceFile;
                }
                if (this.list[0].CollectedQuestionnaireId != '' || this.list[0].CollectedQuestionnaireId != null) {
                  this.EditQuestionnaire(this.list[0], 0);
                }
              }
            }
            this.flag = false;
          }
        } else {
          alert(res.data.Message);
        }
      });
    },
    //编辑
    EditQuestionnaire(item, index) {
      if (this.active == index) {
        return;
      }
      this.active = index;
      this.item = item;
      this.Url = '';
      //maybe status=05
      if (item.CollectedQuestionnaireId == null || item.CollectedQuestionnaireId == '') {
        this.videoUrl = '';
        return;
      }
      if (item.Status == '08') {
        this.Url = `${window.global_config.BASE_URL1}/#/PcIframe?qid=${item.CollectedQuestionnaireId}&type=5&r=${Math.random() * 10}`;
        // this.Url = `${window.global_config.BASE_URL1}/#/ViewModification?cqId=${
        //   item.CollectedQuestionnaireId
        // }&r=${Math.random() * 10}`;
        // this.Url = "about:blank";
        this.videoUrl = item.VoiceFile;

        setTimeout(() => {
          this.Url = `${window.global_config.BASE_URL1}/#/PcIframe?qid=${item.CollectedQuestionnaireId}&type=5&r=${Math.random() * 10}`;
          // this.Url = `${
          //   window.global_config.BASE_URL1
          // }/#/ViewModification?cqId=${item.CollectedQuestionnaireId}&r=${
          //   Math.random() * 10
          // }`;
        }, 300);
      } else {
        derive.EditFollowUpRecordsData().then(res => {
          if (res.data.Status == 1) {
            this.Url = `${window.global_config.BASE_URL1}/#/PcIframe?qid=${item.CollectedQuestionnaireId}&type=5&r=${Math.random() * 10}`;
            // this.Url = `${res.data.Data.Url}/#/P?type=3&qid=${
            //   item.CollectedQuestionnaireId
            // }&r=${new Date().getTime()}`;
            this.videoUrl = '';
          } else {
            alert(res.data.Message);
          }
        });
      }
    },
    //删除
    DeleteQuestionnaire(rows) {
      this.$confirm('此操作将永久删除随访信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let parameter = [];
        /**
         * parameter.push(this.item.Id)
         */
        parameter.push(rows.Id);

        //   const parameter={
        //     CollectedQuestionnaireId:this.item.CollectedQuestionnaireId,
        //     Id:this.item.Id,
        //     Channel:this.item.Channel,
        //  }
        derive.DeleteFollowUpRecordsData(parameter).then(res => {
          if (res.data.Status == 1) {
            this.Url = '';
            if (this.item.Channel == '03') {
              this.list = this.list.filter(row => {
                return row.Id != this.item.Id;
              });
            }
            //  this.FollowUpRecords()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.page = 1;
            this.list = [];
            this.active = 0;
            this.flag = false;
            this.FollowUpRecords();
          } else {
            alert(res.data.Message);
          }
        });
      });
    },
    Scroll(e) {
      // console.log(this.$refs.evabox.scrollTop)
      const ele = e.srcElement ? e.srcElement : e.target;
      // 监听滚动到div底部
      if (ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 2) {
        if (this.flag == false) {
          this.flag = true;
          this.page++;
          if (this.list.length < this.total) {
            this.FollowUpRecords();
          } else {
            this.$message({
              message: '已经没有更多数据了',
              type: 'success'
            });
          }
        }
      }
    },
    async getInspectPageList() {
      let res = await derive.inspectPageList(this.params);
      this.total2 = res.data.Data.total;
      this.dataList.push(...res.data.Data.rows);
      if (this.dataList.length >= this.total2) {
        this.isLoad = false;
      }
    },
    async handleSubmit() {
      if (this.textarea === '') return this.$message.error('请填写建议');
      // console.log(this.item);
      let res = await derive.addInspect({
        FollowUpTaskId: this.item.Id,
        Comment: this.textarea
      });
      this.textarea = '';
      console.log(res.data.Data);
      this.dataList.unshift(res.data.Data);
      this.total2++;
    },
    async handleRemove(item, idx) {
      let res = await derive.delInspect([item.Id]);
      this.dataList.splice(idx, 1);
      this.total2--;
    },
    async handleEdit(item, idx) {
      this.editVal = item.Comment;
      this.editShow = idx;
    },
    async handleBlur(item, idx) {
      if (this.editVal === item.Comment || this.editVal === '') return (this.editShow = false);
      let res = await derive.editInspect({
        FollowUpTaskId: item.FollowUpTaskId,
        Id: item.Id,
        Comment: this.editVal
      });
      this.dataList[idx].Comment = this.editVal;
      this.editVal = '';
      this.editShow = false;
    }
  },
  watch: {
    item: {
      handler(val) {
        console.log(val);
        this.params.FollowUpTaskId = val.Id;
      },
      deep: true
    }
  },
  mounted() {
    let OB = new IntersectionObserver((e, o) => {
      if (e[0].isIntersecting) {
        this.getInspectPageList();
        this.params.page++;
      }
    });
    OB.observe(this.$refs.isLoad);
  }
};
</script>

<style scoped lang="scss">
@import '../../styles/mixin.scss';
.loadMore {
  text-align: center;
  font-size: 14px;
  user-select: none;
  color: #666;
}
.active {
  border: 1px solid #3388ff !important;
}

.btn {
  // width: 40px;
  position: absolute;
  bottom: 40px;
  right: 100px;

  /deep/.el-button {
    height: 40px;
    background: red !important;
  }
}

#videocalss {
  position: absolute;
  top: 60px;
  right: 100px;
  width: 400px;
  height: 40px;
}

.task-details-left {
  width: 340px;
  height: 100%;
  overflow: hidden;
  background-color: #ffffff;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  padding-left: 20px;
  box-sizing: border-box;
  transition: 0.3s;

  .call-phone {
    margin-bottom: 30px;

    /deep/.el-button {
      width: 299px;
      height: 40px;
      color: #3388ff;
      font-weight: 400;
      background: rgba(57, 120, 231, 0.15);
      border: 1px solid rgba(51, 136, 255, 0.5686274509803921);
      border-radius: 4px;
      margin-left: inherit;
    }
  }

  .span-name {
    font-size: 24px;
    font-weight: 500;
    line-height: 41px;
    color: #585858;
    margin-right: 24px;
  }

  .span-text {
    @include common_span;
  }

  .span-task-details {
    @include common_span;
  }

  .show-beizhu {
    ul {
      width: 300px;

      li {
        width: 300px;
        height: 180px;
        background: #f7f7f7;
        border-radius: 4px;
        margin-bottom: 10px;
        padding: 16px 17px 0 8px;
        box-sizing: border-box;

        .span-time {
          @include add-size5($font_size_14);
          font-weight: 400;
          line-height: 24px;
          color: #c7c7c7;
        }

        .bei-zhu-info {
          width: 284px;
          height: 97px;
          position: relative;
          @include add-size($font_size_16);
          font-weight: 400;
          color: #585858;
          margin-top: 20px;
          box-sizing: border-box;
        }
      }
    }
  }

  .show-shufang {
    .no-content {
      width: 288px;
      text-align: center;
      margin: 121px auto 0 auto;

      p {
        width: 288px;
        font-size: 16px;
        font-weight: 400;
        line-height: 27px;
        color: #aaafb5;
      }
    }

    ul {
      p {
        font-size: 18px;
        font-weight: 500;
        line-height: 31px;
        color: #333333;
      }

      li {
        p {
          font-size: 18px;
          font-weight: 500;
          line-height: 31px;
          color: #333333;
        }

        .task-content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 300px;
          height: 120px;
          background: #f7f7f7;
          opacity: 1;
          border-radius: 4px;
          padding: 18px 0 16px 12px;
          box-sizing: border-box;

          span {
            @include common_span;
          }
        }
      }
    }
  }
}

.task-details-right {
  // width: 1540px;
  flex: 1;
  height: 100%;
  background-color: #ffffff;
  margin-top: 10px;

  .no-content {
    width: 288px;
    text-align: center;
    margin: 30% auto 0 auto;

    p {
      width: 288px;
      font-size: 16px;
      font-weight: 400;
      line-height: 27px;
      color: #aaafb5;
    }
  }
}

/deep/.el-radio-button {
  width: 150px;

  .el-radio-button__inner {
    width: 150px;
  }
}

/deep/.el-divider--horizontal {
  margin: 6px 0;
}

@media screen and (-webkit-min-device-pixel-ratio: 1.5) {
  #videocalss {
    width: 120px;
  }

  .padHeight {
    height: 950px !important;

    .peoplePic {
      margin-left: 0 !important;
      margin-top: 15px !important;
    }
  }
}
</style>
